/** @format */

import { LoggerLevel } from '../enums/logger-level.enum';

export class LoggerConfig {
  clientLoggerLevel: LoggerLevel = LoggerLevel.OFF;
  xhrLoggerLevel: LoggerLevel = LoggerLevel.OFF;
  xhrLoggerUrl: string | undefined = undefined;
}
